import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { DtoEventShortForm } from '../../../core/services/api/models/DtoEventShortForm';

export interface KioskEventsState extends EntityState<DtoEventShortForm> {}
export const kioskEventsAdapter = createEntityAdapter<DtoEventShortForm>({
  selectId: (e) => e.ID,
});
